// extracted by mini-css-extract-plugin
export default {"title":"_060926ac6a","bld":"de1ad95b9c"};